import clsx from "clsx";
import { Moon, Sun } from "lucide-react";

import type { ColorScheme } from "../hooks/useColorScheme";

type ThemeToggleProps = {
  value: ColorScheme;
  onChange: (scheme: ColorScheme) => void;
};

export function ThemeToggle({ value, onChange }: ThemeToggleProps) {
  const isDark = value === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-label="Basculer le thème"
      aria-checked={isDark}
      onClick={() => onChange(isDark ? "light" : "dark")}
      className={clsx(
        "relative inline-flex h-10 w-20 items-center justify-between rounded-full p-1 transition-all duration-500 ease-in-out",
        "bg-zinc-100 border border-zinc-200 hover:bg-zinc-200",
        "dark:bg-zinc-900 dark:border-zinc-800 dark:hover:bg-zinc-800",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-400 focus-visible:ring-offset-2",
        "dark:focus-visible:ring-zinc-600",
      )}
    >
      {/* Icône Sun */}
      <span
        className={clsx(
          "relative z-10 flex h-8 w-8 items-center justify-center rounded-full transition-all duration-500 ease-in-out",
          !isDark
            ? "bg-white text-zinc-900 shadow-sm"
            : "text-zinc-400 dark:text-zinc-500",
        )}
      >
        <Sun
          className={clsx(
            "h-4 w-4 transition-all duration-500",
            !isDark ? "scale-100" : "scale-90 opacity-60",
          )}
          aria-hidden
        />
      </span>

      {/* Icône Moon */}
      <span
        className={clsx(
          "relative z-10 flex h-8 w-8 items-center justify-center rounded-full transition-all duration-500 ease-in-out",
          isDark
            ? "bg-zinc-800 text-white shadow-sm dark:bg-zinc-700"
            : "text-zinc-400",
        )}
      >
        <Moon
          className={clsx(
            "h-4 w-4 transition-all duration-500",
            isDark ? "scale-100" : "scale-90 opacity-60",
          )}
          aria-hidden
        />
      </span>
    </button>
  );
}
